import { render, staticRenderFns } from "./logTransportes.vue?vue&type=template&id=53a7c770&"
import script from "./logTransportes.vue?vue&type=script&lang=js&"
export * from "./logTransportes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports